export default ({ app }) => {
  app.router.onReady(() => {
    const { hash } = window.location

    if (hash) {
      const checkElement = (retries = 30) => {
        const element = document.querySelector(hash)

        if (element) {
          setTimeout(() => {
            const position =
              element.getBoundingClientRect().top + window.scrollY
            window.scrollTo({ top: position, behavior: 'smooth' })
          }, 100)
        } else if (retries > 0) {
          setTimeout(() => checkElement(retries - 1), 200)
        }
      }

      checkElement()
    }
  })
}
